import { render } from "./index.vue?vue&type=template&id=c97f7682&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=c97f7682&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=c97f7682&lang=scss&scoped=true"

import exportComponent from "/Users/admin/Codes/d86e-client-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c97f7682"]])

export default __exports__